import { Button, Image, Text } from "theme-ui";

import FilterIcon from '../../../assets/images/Icon/filterIcon.png';
import SelectIcon from '../../../assets/images/Icon/select.svg';
const FilterButton: React.FC<{
    onClick: () => void;
    label: React.ReactNode;
    sx?: any;
}> = ({ onClick, label, sx }) => (
    <Button onClick={onClick} className="dashboardFilterButton" sx={{ padding: "8px", border: "1px solid rgba(141, 141, 141, 0.2)" }}>
        <Image src={FilterIcon} />
        <Text sx={{ fontSize: "14px", marginLeft: '8px', marginRight: '8px', color: 'rgba(141, 141, 141, 1)' }}>{label}</Text>
        <Image src={SelectIcon} />
    </Button>
);

export default FilterButton